import { SUBSCRIPTION_INTERVALS } from "../../common/constants";

export const getSubscribeMutation = ({ shopId, shopName, name, price, plan, interval }) => `
mutation {
    appSubscriptionCreate(
      name: "${name}"
      returnUrl: "https://admin.shopify.com/store/${shopName}/apps/timesact-discount-pre-order/account?shop_id=${shopId}&plan=${plan}"
      test: false,
      lineItems: [{
        plan: {
          appRecurringPricingDetails: {
            price: { amount: ${price}, currencyCode: USD }
            interval: ${interval}
          }
        }
      }]
    ) {
      userErrors {
        field
        message
      }
      confirmationUrl
      appSubscription {
        id
      }
    }
  }
`;

export const getSubscribeCustomMutation = ({
  shopId,
  shopName,
  price,
  plan,
  preorders,
  preordersPrice,
  instock,
  instockPrice,
  bisNotifications,
  bisNotificationsPrice,
  interval = SUBSCRIPTION_INTERVALS.MONTHLY,
  name = "Timesact CUSTOM",
}) => `
mutation {
    appSubscriptionCreate(
      name: "${name}"
      returnUrl: "https://admin.shopify.com/store/${shopName}/apps/timesact-discount-pre-order/account?shop_id=${shopId}&p=${plan}&c=${price}&po=${preorders}&pop=${preordersPrice}&is=${instock}&isp=${instockPrice}&bn=${bisNotifications}&bnp=${bisNotificationsPrice}"
      test: false,
      lineItems: [{
        plan: {
          appRecurringPricingDetails: {
            price: { amount: ${price}, currencyCode: USD }
            interval: ${interval === SUBSCRIPTION_INTERVALS.MONTHLY ? "EVERY_30_DAYS" : "ANNUAL"}
          }
        }
      }]
    ) {
      userErrors {
        field
        message
      }
      confirmationUrl
      appSubscription {
        id
      }
    }
  }
`;

export const getUnsubscribedMutation = (chargeId) => `
mutation {
    appSubscriptionCancel(
      id: "gid://shopify/AppSubscription/${chargeId}"
    ) {
      userErrors {
        field
        message
      }
      appSubscription {
        id
        status
      }
    }
  }
`;

export const getScriptTagCreateMutation = (scriptVersion) => `
mutation { scriptTagCreate(input: {
    cache: true,
    displayScope: ONLINE_STORE,
    src: "https://storage.googleapis.com/timesact-resources/scripts/${scriptVersion}"
}) {
    scriptTag {
      id
    }
    userErrors {
      field
      message
    }
  }
}
`;

export const getAllScriptTags = () => `
{
  scriptTags(first: 5) {
    edges {
      node {
        id
      }
    }
  }
}
`;

export const getRemoveScriptTagMutation = (id) => `
mutation { scriptTagDelete(id: "${id}") {
    deletedScriptTagId
    userErrors {
      field
      message
    }
  }
}
`;
